import {ErrorModel} from '../../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../../root';
const FUNCTION_CODE = 'GET_ALL_DASHBOARD_CONSULTANT_PRODUCTION';

export async function getAllActivities(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/consultant/activity/?${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
